import React, { useEffect, useState } from 'react'
import '../components/css/events.css';

import { Button, Carousel, Container, Modal } from 'react-bootstrap';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import f11 from '../components/images/Image 1.JPG';
import SixCardSlider from '../components/EventSection/SixCardSlider';

import c1 from '../components/images/IMG (34).webp'
import c2 from '../components/images/IMG (31).webp'

import { BsFillPlayFill } from "react-icons/bs";

import vvv from '../components/images/events_vdd/Our Event.mp4';
import { useDispatch, useSelector } from 'react-redux';
import { getEventConfig } from '../App/Slices/eventsSlice';
import webinar from '../components/images/Webinar.jpg';
import publication from '../components/images/Digital Publication.jpg';
import img1 from '../components/images/Conference & Events.jpg';
import img2 from '../components/images/Slider 2webp.webp';
import img3 from '../components/images/Slider 3webp.webp';
import img4 from '../components/images/Slider 4webp.webp';
import img5 from '../components/images/Slider 5webp.webp';
import img6 from '../components/images/Slider 6webp.webp';
import { Helmet } from 'react-helmet-async';
const Events = () => {
  const [latestWebinar, setLatestWebinar] = useState(null);
  const [latestPublication, setLatestPublication] = useState(null);
  const { eventconfig } = useSelector((state) => state.eventsData);
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const dispatch = useDispatch();
  // Fetch the latest webinar on mount
  useEffect(() => {
    const fetchWebinar = async () => {
      try {
        setLatestWebinar(eventconfig && eventconfig.length > 0 ? eventconfig[0]?.link1 : null);
        setLatestPublication(eventconfig && eventconfig.length > 0 ? eventconfig[0]?.link2 : null);
      } catch (err) {
        console.error(err);
        // toast.error('❌ Failed to fetch webinar info.');
      }
    };

    fetchWebinar();
  }, [eventconfig]);

  const handleJoinNow = async () => {
    if (latestWebinar) {
      window.open(latestWebinar, '_blank');
    } else {
      toast.warning('🛑 No webinar is currently available. Please check back later.');
    }
  };

  const slides = [
    {
      id: 1,
      image: img1,

    },
    {
      id: 2,
      image: img2,

    },

    {
      id: 3,
      image: img3,

    },

    {
      id: 4,
      image: img4,

    },
    {
      id: 5,
      image: img5,

    },
    {
      id: 6,
      image: img6,

    },
  ];

  // Handle download or redirection
  const handleDownload = () => {
    if (latestPublication && latestPublication) {
      window.open(latestPublication, '_blank');
    } else {
      toast.warning('🛑 No publication is currently available. Please check back later.');
    }
  };


  useEffect(() => {
    dispatch(getEventConfig());
  }, [dispatch]);
  return (
    <>

      {/* Helmet for SEO */}
      <Helmet>
        <title>PANAV BIOTECH IN ASSOCIATION WITH PETS PRACTITIONERS ASSOCIATION OF MUMBAI (PPAM) ORGANIZED PANAV BIOTECH SYMPOSIUM 2023</title>
        <meta name="description" content='Panav Biotech and Candioli Pharma in association with PETS PRACTITIONERS ASSOCIATION OF MUMBAI (PPAM) Organized Panav Biotech Symposium 2023 on New Diagnosis and Management of Chronic Kidney Disease (CKD) & Chronic Pain. The event was held at the Radisson Blu Mumbai, and over 200 veterinarians attended the event.' />
        <meta property="og:title" content='PANAV BIOTECH IN ASSOCIATION WITH PETS PRACTITIONERS ASSOCIATION OF MUMBAI (PPAM) ORGANIZED PANAV BIOTECH SYMPOSIUM 2023' />
        <meta property="og:description" content='Panav Biotech and Candioli Pharma in association with PETS PRACTITIONERS ASSOCIATION OF MUMBAI (PPAM) Organized Panav Biotech Symposium 2023 on New Diagnosis and Management of Chronic Kidney Disease (CKD) & Chronic Pain. The event was held at the Radisson Blu Mumbai, and over 200 veterinarians attended the event.' />
        <meta property="og:image" content={f11} />
      </Helmet>
      <Carousel interval={3000} fade={true} pause="hover" indicators={true}>
        {slides.map((slide) => (
          <Carousel.Item key={slide.id} className="carousel-item">
            {/* Background Image */}

            <div className="carousel-images-home">
              <img src={slide.image} alt={`Slide ${slide.id}`} className="img-fluid w-100" loading='lazy' />
            </div>


          </Carousel.Item>
        ))}
      </Carousel>
      <section className='our-last-year-section-cont'>
        <img src={c2} alt="Welcome" className='left-side-half-circle-our-last-year-section' loading='lazy' />
        <Container>
          <div className="row justify-content-center events-our-last-year-row align-items-stretch">
            <div className="col-lg-6 col-md-6 col-12 p-0 order-2 order-md-1">
              <div className="image-wrapper">
                <img src={f11} className="img-fluid w-100 h-100" alt="Last Year Event" loading='lazy' />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 ourlast-year-section-evenst order-1 order-md-2">
              <div className="content-wrapper">
                <h2 className="text-centerr">Our Last Year Event</h2>
                <p>PANAV BIOTECH SYMPOSIUM 2023 <br /><br />
                  PANAV BIOTECH IN ASSOCIATION WITH PETS PRACTITIONERS ASSOCIATION OF MUMBAI (PPAM) ORGANIZED PANAV BIOTECH SYMPOSIUM 2023 <br /><br />
                  Panav Biotech and Candioli Pharma in association with PETS PRACTITIONERS ASSOCIATION OF MUMBAI (PPAM) Organized Panav Biotech Symposium 2023 on New Diagnosis and Management of Chronic Kidney Disease (CKD) & Chronic Pain. The event was held at the Radisson Blu Mumbai, and over 200 veterinarians attended the event.</p>

                <Button
                  onClick={handleShow}
                  className="play-button-custom text-black"
                >
                  <BsFillPlayFill className="w-8 h-8" />
                </Button>

              </div>
            </div>
          </div>
        </Container>
        <img src={c1} alt="Welcome" className='right-side-half-circle-our-last-year-section' loading='lazy' />

        {/* modal for videos */}
        <Modal show={show} onHide={handleClose} centered size="lg" className="video-modal">
          <Modal.Body className="p-0">
            <div className="ratio ratio-16x9">
              <video
                width="100%"
                height="auto"
                autoPlay
                controls
                preload="none"

                controlsList="nodownload fullscreen noremoteplayback noplaybackrate novolume"
                style={{
                  pointerEvents: 'auto',
                }}
              >
                <source src={vvv} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </Modal.Body>
        </Modal>
      </section>

      <section>
        <SixCardSlider />
      </section>

      {/* <section className='join-our-int-web-event-section'>
        <Container>
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-6 col-12 join-our-int-colmn1 order-1">
              <div className="content-wrapper">
                <h2>Join Our Interactive Webinars and Google Meet Sessions!</h2>
                <p>Stay ahead with real-time learning experiences, expert insights, and live Q&A sessions!</p>
                <Button onClick={handleJoinNow} className="join-btn-custom">Join Now</Button>
                <small className="text-muted datetime-text">
                  Starting Date Time: {eventconfig && eventconfig.length > 0 ? eventconfig[0].datetime1 : 'Not Available'}
                </small>


              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 order-2">
              <div className="image-wrapper">
                <img src={webinar} className='img-fluid w-100' alt="Webinar" loading='lazy' />
              </div>
            </div>
          </div>
        </Container>
      </section> */}

      <section className='digital-publications-events-section'>
        <Container>
          <div className="row justify-content-center align-items-stretch">
            <div className="col-lg-6 col-md-6 col-12 p-0 order-2 order-md-1">
              <div className="image-wrapper">
                <img src={publication} className='img-fluid w-100 h-100' alt="Digital Publication" loading='lazy' />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 digital-publications-events-colmn2 order-1 order-md-2">
              <div className="content-wrapper">
                <h2>Digital Publication and Interactive Webinars</h2>
                <p>Featured in Leading Publications
                  Recognized across top digital platforms and industry magazines, Panav Biotech continues to be a trusted voice in veterinary pharma.</p>
                <Button onClick={handleDownload} className="read-btn-custom">
                  Read More
                </Button>
                <small className="text-mutedd text-white datetime-text">
                  Starting Date Time: {eventconfig?.[0]?.datetime2 ?? 'Not Available'}
                </small>
              </div>
            </div>
          </div>
        </Container>
        <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      </section>
    </>

  )
}

export default Events